module.exports = __webpack_public_path__ + "static/media/Olivia Young.1d91d013.jpg";